"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertItemToString = void 0;
const convertItemToString = (item) => {
    if (typeof item === 'string') {
        return item;
    }
    return item.join(', ');
};
exports.convertItemToString = convertItemToString;
